export default {
    en: {
        number: 4,
        diagramId: 3,
        answers: 'western window western window',
        interactiveBoxNumber: [1],
        blocks:
            [
                {
                    task: {
                        question: 'The western window is the only window that looks directly out on the moor',
                        answer: '<span class="correct-answer-box">The <span class="highlight__answer highlight__answer_correct">western window</span> is the only window that looks directly out on the moor</span>'
                    },
                    example: true
                },
                {
                    task: {
                        question: 'Barrymore was staring out of the western window',
                        answer: '<span class="correct-answer-box">Barrymore was staring out of the <span class="highlight__answer highlight__answer_correct">western window</span></span>'
                    },
                    selectAvailable: true
                },
                {
                    task: {
                        question: 'Therefore Barrymore must have been looking for something or someone on the moor',
                        answer: '<span class="correct-answer-box">Therefore Barrymore must have been looking for something or someone on the moor</span>'
                    }
                }
            ]
    }
};



// WEBPACK FOOTER //
// ./client/app/modules/courses/3/3a1/deductiveReasoning/i18n/exercise4.js